export default __webpack_public_path__ + "static/media/no_record.2ebc6dd3.png";